/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-boolean-value */
import React, { useEffect, useState } from "react";
import utils from "utils";
import "./lobby.scss";
import { UmbracoProvider } from "components/Umbraco/UmbracoContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { isMobile } from "react-device-detect";
import Layout from "Layout";
import Section1 from "./components/section1";
import Section2 from "./components/section2";

import Section3 from "./components/section3";
import Section4 from "./components/section4";
import Section5 from "./components/section5";
import Section6 from "./components/section6";

import Footer from "./components/footer";
import * as Constants from "../../utils/constants";

const { rest } = utils;
const SITE_KEY = Constants.RECAPTCHA_CURRENT_ENV;

export default function Lobby() {
  useEffect(() => {
    const script = document.createElement("script");
    script.append(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-KZFXLQC');`);
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-KZFXLQC";
    iframe.height = "0";
    iframe.width = "0";
    iframe.style = "display:none;visibility:hidden";
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);

    getLobbyDetails();
  }, []);
  const getLobbyDetails = async () => {
    const formData = {};
    formData.guid = localStorage.getItem("investPolicyGUID");
    const result = await rest.post('/api/Manager/GetLobbyDetails', {
      data: formData,
    });
    result.data.calculetedHerkevTik.sort((a, b) =>
      a.totalAfikPercent < b.totalAfikPercent ? 1 : -1
    );
    const userRiskLevel = result.data.riskLevel;
    window.dataLayer.push({
      event: "PM - ivestment",
      eventInfo: {
        action_screen: window.location.pathname,
        user_risk_level: userRiskLevel,
        process_level: "הרכב תיק השקעות",
        action_name: "הגעה למסך סיום - הרכב תיק ההשקעות",
      },
    });

    setLobbyDetailsData(result.data);
  };
  const [lobbyDetailsData, setLobbyDetailsData] = useState([]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY} useEnterprise="true" scriptProps={{ async: true }}>
      <UmbracoProvider umbracoUrl="/api/home/GetPage/Lobby/LobbyPage">
        {lobbyDetailsData.calculetedHerkevTik != null ? (
          <div>
            <Layout lobby={true}>
              <div
                className={`${
                  isMobile ? "sectionsMobile" : ""
                } sections col-xs-12 p-0 m-0`}
              >
                <Section1 lobbyDetailsData={lobbyDetailsData} />
                <Section6 lobbyDetailsData={lobbyDetailsData} setLobbyDetailsData={setLobbyDetailsData}/>
                <Section2 lobbyDetailsData={lobbyDetailsData} />
                <Section3 />
                <Section4 />
                <Section5 />
                <Footer />
              </div>
            </Layout>
          </div>
        ) : null}
      </UmbracoProvider>
    </GoogleReCaptchaProvider>
  );
}
